module.exports = __webpack_public_path__ + "static/media/alert-success.ced88328.svg";